import { useEffect, useState } from 'react';
import { useAPI } from 'src/services/api';
import { Table, Button, Modal } from 'react-bootstrap';

const Submissions = () => {
  const api = useAPI();
  const [submissionData, setSubmissionData] = useState([]);
  const [lgShow, setLgShow] = useState(false);
  const [activeSubmission, setActiveSubmission] = useState({});

  useEffect(() => {
    const getAllSubmissions = async () => {
      const { data } = await api.get('/submissions');
      setSubmissionData([...data]);
    };
    getAllSubmissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleShowModal = (submission) => {
    setActiveSubmission(submission);
    setLgShow(true);
  };

  const submissionModal = () => {
    return (
      <>
        <Modal
          size="lg"
          show={lgShow}
          onHide={() => setLgShow(false)}
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">Submission Information</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table>
              <tbody>
                <tr>
                  <th>Submission ID</th>
                  <td>{activeSubmission.submissionId}</td>
                </tr>
                <tr>
                  <th>Complainant to remain anonymous?</th>
                  <td>{activeSubmission.anonymity}</td>
                </tr>
                <tr>
                  <th>Response desired?</th>
                  <td>{activeSubmission.responseDesired}</td>
                </tr>
                <tr>
                  <th>Complainant Name</th>
                  <td>{activeSubmission.complainantName}</td>
                </tr>
                <tr>
                  <th>Complainant Role</th>
                  <td>{activeSubmission.complainantRole}</td>
                </tr>
                <tr>
                  <th>Personal Phone Number</th>
                  <td>{activeSubmission.personalPhoneNumber}</td>
                </tr>
                <tr>
                  <th>Home Address</th>
                  <td>
                    {activeSubmission.homeAddressStreetAddress} <br />
                    {activeSubmission.homeAddressCity}, {activeSubmission.homeAddressState}{' '}
                    {activeSubmission.homeAddressZipCode}
                  </td>
                </tr>
                <tr>
                  <th>Work Address</th>
                  <td>
                    {activeSubmission.workAddressStreetAddress} <br />
                    {activeSubmission.workAddressCity}, {activeSubmission.workAddressState}{' '}
                    {activeSubmission.workAddressZipCode}
                  </td>
                </tr>
                <tr>
                  <th>Work Position</th>
                  <td>{activeSubmission.workPosition}</td>
                </tr>
                <tr>
                  <th>Who is Involved?</th>
                  <td>{activeSubmission.whoInvolved}</td>
                </tr>
                <tr>
                  <th>What do you believe the individual did that is improper?</th>
                  <td>{activeSubmission.improperAction}</td>
                </tr>
                <tr>
                  <th>What specific statute/policy do you believe was violated?</th>
                  <td>{activeSubmission.violation}</td>
                </tr>
                <tr>
                  <th>When did the event(s) take place?</th>
                  <td>{activeSubmission.whenOccur}</td>
                </tr>
                <tr>
                  <th>Where did the event(s) occur?</th>
                  <td>{activeSubmission.whereOccur}</td>
                </tr>

                <tr>
                  <th>How do you know about the event(s)?</th>
                  <td>{activeSubmission.source}</td>
                </tr>
                <tr>
                  <th>What evidence exists to support your complaint?</th>
                  <td>{activeSubmission.evidence}</td>
                </tr>
                <tr>
                  <th>Attached Filenames (check email)</th>
                  <td>{activeSubmission.supportingFileNames}</td>
                </tr>
                <tr>
                  <th>Are there other individuals to which you have reported this complaint?</th>
                  <td>{activeSubmission.alsoReportedTo}</td>
                </tr>
                <tr>
                  <th>Litigation Information</th>
                  <td>{activeSubmission.litigationInfo}</td>
                </tr>
              </tbody>
            </Table>
          </Modal.Body>
        </Modal>
      </>
    );
  };

  return (
    <>
      {submissionModal()}
      <h1 className="mt-4 text-center justify-content-center w-100">Submissions</h1>

      <Table>
        <thead>
          <tr>
            <th>Involved Party</th>
            <th>Improper Action</th>
            <th>Time</th>
            <th>Place</th>
          </tr>
        </thead>
        <tbody>
          {console.log(submissionData)}
          {submissionData.map((submission) => {
            return (
              <tr key={submission.id} onClick={() => handleShowModal(submission)}>
                <td>{submission.whoInvolved}</td>
                <td>{submission.improperAction}</td>
                <td>{submission.whenOccur}</td>
                <td>{submission.whereOccur}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
};

export default Submissions;
